export default __webpack_public_path__ + "static/media/products_order_value.e09e03da.svg";